import { Presenter } from '@shared/presenters/presenter';
import type { FixedRate } from './fixed-rate';

export class FixedRatePresenter extends Presenter<FixedRate> {
    get name(): string {
        return this.data.name;
    }
}
